"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MosaicWindowContext = exports.MosaicContext = void 0;
var react_1 = __importDefault(require("react"));
exports.MosaicContext = react_1.default.createContext(undefined);
exports.MosaicWindowContext = react_1.default.createContext(undefined);
//# sourceMappingURL=contextTypes.js.map